var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "about-us" },
        [
          _c(
            "el-container",
            { staticClass: "d-flex-column" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [_vm._v(" ")]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("h1", [_vm._v("Memories")]),
                    _c("p", [
                      _vm._v(
                        "Maren Solutions technologies is gifted with passel of youngsters with highly skilled capabilities of developing products and delivering on time. We have a team that includes people across our country knowing the ropes in their fields. We believe unity in diversity"
                      )
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-container",
        { staticClass: "d-flex-column p-tb50 text-center" },
        [
          _c("h2", [_vm._v("Eid Gallery")]),
          _c("p", [
            _vm._v(
              "Our team is your team. Digital specialists, tech wizzes and creative superstars –  "
            ),
            _c("span", { staticClass: "d-block" }, [
              _vm._v(" they know how to make a difference to your business. ")
            ])
          ]),
          _c(
            "el-carousel",
            { attrs: { interval: 5000, type: "card", arrow: "always" } },
            [
              _c("el-carousel-item", [
                _c("div", { staticClass: "memories-slide" }, [
                  _c("img", {
                    staticClass: "awards-img",
                    attrs: {
                      src: require("../../../public/img/memories/eid1.png"),
                      alt: "awards"
                    }
                  })
                ])
              ]),
              _c("el-carousel-item", [
                _c("div", { staticClass: "memories-slide" }, [
                  _c("img", {
                    staticClass: "awards-img",
                    attrs: {
                      src: require("../../../public/img/memories/eid2.png"),
                      alt: "awards"
                    }
                  })
                ])
              ]),
              _c("el-carousel-item", [
                _c("div", { staticClass: "memories-slide" }, [
                  _c("img", {
                    staticClass: "awards-img",
                    attrs: {
                      src: require("../../../public/img/memories/eid3.jpg"),
                      alt: "awards"
                    }
                  })
                ])
              ])
            ],
            1
          ),
          _c("h2", [_vm._v("Holi vibes")]),
          _c("p", [
            _vm._v(
              "Our team is your team. Digital specialists, tech wizzes and creative superstars –  "
            ),
            _c("span", { staticClass: "d-block" }, [
              _vm._v(" they know how to make a difference to your business. ")
            ])
          ]),
          _c(
            "el-carousel",
            { attrs: { interval: 5000, type: "card", arrow: "always" } },
            [
              _c("el-carousel-item", [
                _c("div", { staticClass: "memories-slide" }, [
                  _c("img", {
                    staticClass: "awards-img",
                    attrs: {
                      src: require("../../../public/img/memories/game.png"),
                      alt: "awards"
                    }
                  })
                ])
              ]),
              _c("el-carousel-item", [
                _c("div", { staticClass: "memories-slide" }, [
                  _c("img", {
                    staticClass: "awards-img",
                    attrs: {
                      src: require("../../../public/img/memories/holi2.png"),
                      alt: "awards"
                    }
                  })
                ])
              ]),
              _c("el-carousel-item", [
                _c("div", { staticClass: "memories-slide" }, [
                  _c("img", {
                    staticClass: "awards-img",
                    attrs: {
                      src: require("../../../public/img/memories/awards.png"),
                      alt: "awards"
                    }
                  })
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/views/static/Memories.vue?vue&type=template&id=b1059654&
// module id = 571
// module chunks = 1